import { render } from "./VideoPlayerStatsTable.vue?vue&type=template&id=6b9b7493&scoped=true"
import script from "./VideoPlayerStatsTable.vue?vue&type=script&lang=js"
export * from "./VideoPlayerStatsTable.vue?vue&type=script&lang=js"

import "./VideoPlayerStatsTable.vue?vue&type=style&index=0&id=6b9b7493&lang=scss&scoped=true"

import exportComponent from "/Users/tpere/RocketBears/vue-viewer-plugin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9b7493"]])

export default __exports__